import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ChartConfiguration, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ReportService } from '@app/shared/services/report/report.service';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
//
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import { MatDialog } from '@angular/material/dialog';
import { AddChecklistComponent } from '@app/modules/checklist/components/dialogs/add-checklist/add-checklist.component';
import { SharedConfirmationDialogComponent } from '../../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '@app/shared/services';
import * as reportActions from '../../../../root-store/report-store/actions';
import { loginStoreActions, RootStoreState } from '@app/root-store';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { formatValueWithComma } from '@app/shared/packages/image-cropper/utils/format-number-withcomma.utils';
import { RegisterBalance2Component } from '../../register-balance-2/register-balance-2.component';
import moment from 'moment';
import { ShareService } from '@app/shared/services/vault/share.service';
import { HomeObsService } from '@app/modules/home-page/home/home-obs.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'report-card-networth',
  templateUrl: './report-card-networth.component.html',
  // styleUrls: ['./report-card-networth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCardNetworthComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('myCanvas') canvas: ElementRef;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Output() RegisterBalanceComponentEmitter: EventEmitter<any> = new EventEmitter();
  @Input() report;
  @Input() isFamilyTreeCard = false;
  @Input() familyTree: any;
  @Input() familyTreeHandlers?: {
    navigate?: (id: string) => void;
    manage?: (event: boolean, id: string) => void;
    rename?: (familyTree: any) => void;
    delete?: (familyTree: any) => void;
  };
  @Input() index = 0;
  @Input() currentFormId;
  @Input() fromBalanceRegister = false;
  @Input() title;
  @Input() fromCurrentBalance = false;
  @Input() isRemoveEditSaveSharing;
  @Input() mode;
  @Input() connected_to_institution;
  @Input() attribute;
  @Input() currentVaultUserId;
  @Input() balanceType;
  @Input() financialAttributes;
  @Input() attribute_type = '';
  @Input() fromAttribute = false;
  @Input() unstringCommitmentBalance;
  @Output() arrayLengthChanged = new EventEmitter<number>();
  @Input() isFromHomePage?: boolean = false;
  period_time;
  report_tag_isUpdate = false;
  trendExecutionSub;
  isUdpatedDate;
  screenWidth: number;
  isLoading = true;
  showRefreshPrompt = false;
  public lineChartData: ChartConfiguration['data'];
  report_execution_id;
  colorArray = [
    '#00E680',
    '#FF6633',
    '#FF33FF',
    '#FFFF99',
    '#00B3E6',
    '#E6B333',
    '#3366E6',
    '#999966',
    '#99FF99',
    '#B34D4D',
    '#80B300',
    '#809900',
    '#E6B3B3',
    '#6680B3',
    '#FFB399',
    '#66991A',
    '#FF99E6',
    '#CCFF1A',
    '#FF1A66',
    '#E6331A',
    '#33FFCC',
    '#66994D',
    '#B366CC',
    '#4D8000',
    '#B33300',
    '#CC80CC',
    '#66664D',
    '#991AFF',
    '#E666FF',
    '#4DB3FF',
    '#1AB399',
    '#E666B3',
    '#33991A',
    '#CC9999',
    '#B3B31A',
    '#00E680',
    '#4D8066',
    '#809980',
    '#E6FF80',
    '#1AFF33',
    '#999933',
    '#FF3380',
    '#CCCC00',
    '#66E64D',
    '#4D80CC',
    '#9900B3',
    '#E64D66',
    '#4DB380',
    '#FF4D4D',
    '#99E6E6',
    '#6666FF',
    '#5926e7',
  ];

  public lineChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0,
      },
      point: {
        radius: 0,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      y: {
        min: 0,
        position: 'left',
        ticks: {
          stepSize: 100,
          // Include a dollar sign in the ticks
          callback: function (value: number, index, ticks) {
            let prefixSIgn = '';
            if (value < 0) {
              prefixSIgn = '-';
              value = +value * -1;
            }
            if (value < 1000) {
              return prefixSIgn + '$' + value;
            } else if (value < 1000000) {
              value = +value / 1000;
              return prefixSIgn + '$' + value + 'k';
            }
            if (value >= 1000000 && value < 1000000000) {
              value = +value / 1000000;
              return prefixSIgn + '$' + value + 'M';
            } else if (value >= 1000000000) {
              value = +value / 1000000000;
              return '$' + value + 'B';
            } else {
              return prefixSIgn + '$' + value;
            }
          },
        },
        grid: {
          color: 'rgba(255,255,255)',
        },
      },
      // y1: {
      //   position: 'right',
      //   ticks: {
      //     color: 'rgba(255,255,255)',
      //   },
      // },

      x: {
        grid: {
          color: 'rgba(255,255,255)',
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
    plugins: {
      tooltip: {
        mode: 'index',
        backgroundColor: '#F3F6FA',
        titleFont: {
          size: 17,
          weight: '700',
        },
        titleColor: '#010B18',
        padding: 16,
        cornerRadius: 4,
        bodyColor: '',
        callbacks: {
          label: (data) => {
            let labelsText = `${data.dataset.label}: $${data.formattedValue}`;
            return [labelsText];
          },
          title: (data) => {
            return this.allLabelsWithoutBlank[data[0].dataIndex];
          },
        },
      },
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          color: '#000',
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'xy',
      intersect: false,
    },
  };
  netWorthChartDataArray: any[] = [];
  allLabelsWithoutBlank = [];
  public lineChartType: ChartType = 'line';
  subscription = new Subscription();
  private primesWorker: Worker;
  private imgeWorker: Worker;
  isUpdate = false;
  reportCardOnHomePage = false;
  isBalanceReport = false;
  isCashReport = false;
  showZeroState = false;
  action = '';
  workspaceId;
  private startExecutionWorker: Worker;

  chartRequestObject;
  dateRange = [
    { value: 'till_date', displayText: 'All Data' },
    { value: 'this_year', displayText: 'This Year' },
    { value: 'this_month', displayText: 'This Month' },
    { value: 'previous_30_days', displayText: 'Previous 30 Days' },
    { value: 'this_quater', displayText: 'This Quarter' },
    { value: 'last_quater', displayText: 'Last Quarter' },
    { value: 'last_year', displayText: 'Last Year' },
    { value: 'previous_12_months', displayText: 'Previous 12 Months' },
    { value: 'last_month', displayText: 'Last Month' },
  ];
  selectedRangeValue = this.dateRange[0].value;
  selectedRangeText = this.dateRange[0].displayText;
  reportExecution: any;
  s3Img = '';
  @Input() isBalanceTwo;
  @Input() attributeValues;
  @Input() getValueFromInput;
  @Input() currentuserId = '';
  @Input() isDistributionOrCapitalCommitment = false;
  @Input() reportWidgetContainerWidth: number;
  familyTreeCardImage = 'assets/images/family-tree/family-tree-empty-state.svg';
  constructor(
    private _reportSevice: ReportService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private router: Router,
    private store$: Store<RootStoreState.State>,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private shareService: ShareService,
    private homeObsService: HomeObsService
  ) {
    if (this.router.url.includes('workspace')) {
      const parseUrl = this.router.url.split('/');
      this.workspaceId = parseUrl[2];
    }
  }
  ngAfterViewInit(): void {
    if (this.isFamilyTreeCard) {
      return;
    }
    this.getStatus(this.report?.id);
  }

  ngOnInit(): void {
    if (this.isFamilyTreeCard) {
      return;
    }
    this.reportCardOnHomePage = this.router.url === '/home';
  }

  openUpdateDialog(report) {
    const dialogRef = this.dialog.open(AddChecklistComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      data: { title: 'Report Name', buttonName: 'Rename', currentChecklistName: report.name, isReport: true },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res?.confirmation && res?.checklistName) {
          this.updateReportName(report.id, report.user_id, res?.checklistName);
        }
      })
    );
  }

  updateReportName(vaultId, vaultUserId, vaultName) {
    const payload = {
      id: vaultId,
      user_id: vaultUserId,
      name: vaultName,
    };
    this.subscription.add(
      this._reportSevice.updateReport(payload).subscribe((res) => {
        if (res) {
          this.store$.dispatch(new reportActions.GetReportRequestAction(false));
        }
      })
    );
  }

  deleteReport(report) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      backdropClass: 'custom-box-shadow',
      hasBackdrop: true,
      data: {
        title: `Delete`,
        materialIcon: 'delete',
        text: `This Report will be permanently deleted`,
        proceedTitle: `Delete`,
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          const modelRequest = {
            type: 'report',
            ids: [report.id],
          };
          this.subscription.add(
            this.commonService.moveReportToTrash(modelRequest).subscribe((data) => {
              if (data) {
                this.store$.dispatch(new reportActions.GetReportRequestAction(false));
                this.store$.dispatch(new loginStoreActions.LoginRequestAction());
                this.toastr.success('Report deleted successfully!');
              }
            })
          );
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.primesWorker?.terminate();
    this.imgeWorker?.terminate();

    this.startExecutionWorker?.terminate();
  }
  moveToReport(event) {
    let path = event.path || (event.composedPath && event.composedPath());
    if (path[0].className == 'material-icons') {
      return;
    }
    if (this.report.type == 'cash') {
      const path = this.workspaceId
        ? [`workspace/${this.workspaceId}/reports/${this.report?.id}/cashflow-map`]
        : [`reports/${this.report?.id}/cashflow-map`];
      this.router.navigate(path);
    } else if (this.report.type == 'balance') {
      const path = this.workspaceId
        ? [`workspace/${this.workspaceId}/reports/${this.report?.id}/bs-reports/interactive`]
        : [`reports/${this.report?.id}/bs-reports/interactive`];
      this.router.navigate(path);
    } else if (this.report.type == 'ownership') {
      const path = this.workspaceId
        ? [`workspace/${this.workspaceId}/reports/${this.report?.id}/ownership-map`]
        : [`reports/${this.report?.id}/ownership-map`];
      this.router.navigate(path);
    } else {
      const path = this.workspaceId
        ? [`workspace/${this.workspaceId}/reports/${this.report?.id}/asset-map`]
        : [`reports/${this.report?.id}/asset-map`];
      this.router.navigate(path);
    }
  }
  async getStatus(id) {
    this.isUpdate = false;
    let data = {
      token: '',
      url: '',
    };
    if (this.fromBalanceRegister) {
      this.generateValueHistory();
      return;
    }

    await new Promise(async (resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists before creating new one
        if (this.primesWorker) {
          this.primesWorker.terminate();
        }

        this.primesWorker = new Worker(new URL('../../../../modules/reports/components/balance-sheet/check-report-status.worker', import.meta.url), {
          type: 'classic',
        });

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/report/report-execution-status-updated-date/${id}`;

        this.primesWorker.onmessage = ({ data }) => {
          resolve(data);
          if (data.data.status == 'start' || data.data.status == 'inprogress') {
            this.isLoading = false;
            setTimeout(() => {
              if (!this.subscription.closed) {
                this.getStatus(id);
              }
            }, 15000);
          } else {
            this.period_time = data.data.period;
            this.report_tag_isUpdate = true;
            this.isUdpatedDate = new Date(data.data.updated_at);
            this.showRefreshPrompt = data.data.is_dirty === 1 ? true : false;
            this.homeObsService.handleHomeReportRefresh(this.showRefreshPrompt, this.report?.id);
            this.isLoading = false;

            if (this.report.type == 'balance') {
              this.isBalanceReport = true;
            }
            if (this.report.type == 'cash') {
              this.isCashReport = true;
            }
            if (this.isBalanceReport) {
              this.generateNetworth(data.data.id);
            } else if (this.report.type === 'ownership') {
              this.showZeroState = true;
              this.report_execution_id = data.data.id;
              this.reportExecution = data.data;
              this.getReportImg();
            } else {
              this.showZeroState = true;
              this.report_execution_id = data.data.id;
              this.reportExecution = data.data;
              this.isLoading = false;
              this.cd.detectChanges();
            }
          }
        };
        this.cd.detectChanges();
        this.primesWorker.postMessage(data);
      } else {
        // browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }

  async startReportExecution() {
    this.showZeroState = false;
    this.isUpdate = false;
    this.isLoading = true;
    const data = {
      token: '',
      url: '',
      report_id: this.report?.id,
      period: this.period_time,
    };
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.startExecutionWorker) {
          this.startExecutionWorker.terminate();
        }

        this.startExecutionWorker = new Worker(
          new URL('../../../../modules/reports/components/balance-sheet/start-report-execution.worker', import.meta.url),
          { type: 'classic' }
        );

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/report/report-execution`;
        this.startExecutionWorker.onmessage = ({ data }) => {
          // Terminate worker after completion
          if (this.startExecutionWorker) {
            this.startExecutionWorker.terminate();
            this.startExecutionWorker = undefined;
          }

          resolve(data);
          this.getStatus(this.report?.id);
        };
        this.startExecutionWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }

  setSubSection(reportExecutionSub) {
    this.trendExecutionSub =
      reportExecutionSub.findIndex((x) => x.sub_section == 'trend') >= 0 ? reportExecutionSub.find((x) => x.sub_section == 'trend') : null;
    this.cd.detectChanges();
  }
  generateDataKeyPairCreatForm(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }
  /**
   * Method generate networth array
   */
  async generateNetworth(id): Promise<void> {
    this.showZeroState = false;
    this.isUpdate = false;
    let data = {
      token: '',
      url: '',
    };

    await new Promise(async (resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists before creating new one
        if (this.primesWorker) {
          this.primesWorker.terminate();
        }

        this.primesWorker = new Worker(new URL('../../../../modules/reports/components/balance-sheet/check-report-status.worker', import.meta.url), {
          type: 'classic',
        });
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/report/report-execution-balance-net-worth/${id}/4`;

        this.primesWorker.onmessage = ({ data }) => {
          this.isLoading = false;
          resolve(data);
          let processData = [];
          this.allLabelsWithoutBlank = data.data.allLabelsWithoutBlank;
          let labelList = data.data.labels;
          data.data.reportData.forEach((element, index) => {
            processData.push({
              effective_date: element.effective_date,
              net_worth: element.net_worth,
              total_assets: element.total_assets,
              total_liabilities: element.total_liabilities,
              label: labelList.length > index ? labelList[index] : ' ',
            });
          });
          if (data?.data?.reportData?.length == 0) {
            this.showZeroState = true;
          } else {
            this.showZeroState = false;
          }
          this.netWorthChartDataArray = processData;
          this.setData(
            this.netWorthChartDataArray.map((x) => x.net_worth),
            this.netWorthChartDataArray.map((x) => x.label)
          );
          this.isLoading = false;
          this.cd.detectChanges();
        };
        this.cd.detectChanges();
        this.primesWorker.postMessage(data);
      } else {
        // browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }

  async getReportImg() {
    let data = {
      token: '',
      url: '',
    };
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.imgeWorker) {
          this.imgeWorker.terminate();
        }

        this.imgeWorker = new Worker(new URL('../../../../modules/reports/components/balance-sheet/get-report-img.worker', import.meta.url), {
          type: 'classic',
        });
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/report/attachment-download-url/${this.report.id}`;

        this.imgeWorker.onmessage = async ({ data }) => {
          this.s3Img = data.data;
          this.isLoading = false;
          this.cd.detectChanges();
          resolve(data);
        };
        this.imgeWorker.postMessage(data);
      } else {
        resolve(this.generateCreatePresignedUrl());
      }
    });
  }

  generateCreatePresignedUrl(): unknown {
    throw new Error('Method not implemented.');
  }
  allTransaction = [];
  async generateValueHistory(): Promise<void> {
    this.showZeroState = false;
    this.isUpdate = false;
    this.chartRequestObject = {
      token: '',
      url: '',
      source: this.screenWidth > 480 ? 'not-mobile' : 'mobile',
      period: this.selectedRangeValue,
      vault_user_form_id: this.currentFormId,
      register_type: this.attribute?.value?.vault_form_code,
    };

    if (this.isDistributionOrCapitalCommitment) {
      this.subscription.add(
        this.shareService
          .getBalanceEntry(this.currentVaultUserId, this?.currentFormId, 0, this.attribute?.value?.vault_form_code)
          .subscribe((data) => {
            this.allTransaction = [];
            data?.balanceData?.forEach((transaction, i) => {
              !!transaction.additional_data
                ? this.allTransaction.push({
                    ...JSON.parse(transaction.additional_data),
                    effective_date: transaction.effective_date,
                  })
                : '';
            });
            this.arrayLengthChanged.emit(this.allTransaction.length);
          })
      );
    }
    await new Promise(async (resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        this.primesWorker = new Worker(
          new URL('../../../../modules/reports/components/balance-sheet/start-report-execution.worker', import.meta.url),
          {
            type: 'classic',
          }
        );
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        this.chartRequestObject.token = token;
        this.chartRequestObject.url = `${environment.apiUrl}/api/vault/vault-user-form-value-history`;

        this.primesWorker.onmessage = ({ data }) => {
          this.isLoading = false;
          this.arrayLengthChanged.emit(this.isDistributionOrCapitalCommitment ? this.allTransaction.length : data.data.data_series.length);
          resolve(data);
          let processData = [];
          if (data.data) {
            this.allLabelsWithoutBlank = data.data.allLabelsWithoutBlank;
            let labelList = data.data.labels;
            data.data.data_series.forEach((element, index) => {
              processData.push({
                effective_date: element.effective_date,
                position_value: element.position_value,
                label: labelList.length > index ? labelList[index] : ' ',
              });
            });
          }
          if (data?.data?.data_series?.length == 0) {
            this.showZeroState = true;
          } else {
            this.showZeroState = false;
          }
          this.netWorthChartDataArray = processData;

          if (!this.isDistributionOrCapitalCommitment) {
            this.setData(
              this.netWorthChartDataArray.map((x) => x.position_value),
              this.netWorthChartDataArray.map((x) => x.label)
            );
          } else {
            this.allTransaction = this.allTransaction.sort((a, b) => moment(a.effective_date).diff(moment(b.effective_date)));
            let positionValues = [
              this.unstringCommitmentBalance.total_commitment_usd,
              ...this.handlePositionValuesForCommitment(
                this.unstringCommitmentBalance.total_commitment_usd,
                this.allTransaction.map((x) => x.value)
              ),
            ];

            const earliestDate = this.allTransaction.reduce((min, x) => {
              return moment(x.effective_date, 'YYYY-MM-DD').isBefore(moment(min.effective_date, 'YYYY-MM-DD')) ? x : min;
            }, this.allTransaction[0]);

            const earliestDateMinusOne = moment(earliestDate.effective_date, 'YYYY-MM-DD').subtract(1, 'day').format('MMM DD, YYYY');
            const dates = [earliestDateMinusOne, ...this.allTransaction.map((x) => moment(x.effective_date, 'YYYY-MM-DD').format('MMM DD, YYYY'))];
            dates.sort((a, b) => moment(a).diff(moment(b)));

            this.allLabelsWithoutBlank = dates;
            this.setData(positionValues, dates);
            this.cd.detectChanges();
          }
          this.isLoading = false;
          this.cd.detectChanges();
        };
        this.cd.detectChanges();
        // { method: 'POST', body: this.chartRequestObject }
        this.primesWorker.postMessage(this.chartRequestObject);
      } else {
        resolve(this.generateDataKeyPairCreatForm(this.chartRequestObject));
      }
    });
  }

  handlePositionValuesForCommitment(totalCommitment, contributions) {
    const updatedContributions = [];
    let remaining = totalCommitment;
    for (let i = 0; i < contributions.length; i++) {
      remaining -= contributions[i];
      // if remaining is negative, set it to 0
      if (remaining < 0) {
        remaining = 0;
      }
      updatedContributions.push(remaining);
    }

    return updatedContributions;
  }
  updateDateRange(item) {
    this.selectedRangeValue = item.value;
    this.selectedRangeText = item.displayText;
    this.isLoading = true;
    this.generateValueHistory();
  }

  onResetViewClicked(action) {
    this.action = action;
    if (action == 'updating') {
      this.setData([], []);
    } else {
      this.ngOnInit();
      this.getStatus(this.report?.id);
    }
    this.cd.detectChanges();
  }
  setData(net_worth, labels) {
    this.lineChartData = {
      datasets: [
        {
          data: net_worth,
          label: this.fromBalanceRegister ? 'Position value' : 'Net Assets & Liabilities',
          backgroundColor: '#B9DCDA',
          borderColor: '#B9DCDA',
          pointBackgroundColor: 'rgba(96, 191, 186,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(96, 191, 186,0.8)',
          fill: 'origin',
        },
      ],
      labels: labels,
    };
  }
  @Input() totalDistributions;
  openBalanceRegister() {
    const data = {
      currentFormId: this.currentFormId,
      registerType: 'balance',
      attributeType: this.attribute?.value?.vault_form_code,
      title: this.attribute.key,
      name: this.attribute.key,
      currentuserId: this.currentVaultUserId,
      currentVaultUserId: this.currentVaultUserId,
      connected_to_institution: this.connected_to_institution,
      balanceType: this.balanceType,
      attributeValues: this.attributeValues,
      attribute: this.attribute,
      isBalanceTwo: this.isBalanceTwo,
      getValueFromInput: this.getValueFromInput,
      financialAttributes: this.financialAttributes,
      isEdit: !this.isRemoveEditSaveSharing && this.mode != 'view' ? true : false,
      attribute_type: this.attribute_type,
    };
    const attributeType = this.attribute?.value?.vault_form_code;
    if (attributeType == 'has_distribution' || attributeType == 'has_capital_commitment') {
      this.commonService.distributionRegisterToggleSubject.next({ data, open: true, totalDistributions: this.totalDistributions });
    } else {
      const dialogRef = this.dialog.open(RegisterBalance2Component as any, {
        disableClose: true,
        height: '100%',
        data: data,
        panelClass: this.screenWidth <= 480 ? 'full-window-register' : 'register-balance-dialog',
      });

      this.subscription.add(
        (dialogRef.componentInstance as any).closeTransactionDialog.subscribe(() => {
          dialogRef.close();
          this.RegisterBalanceComponentEmitter.emit();
        })
      );

      this.subscription.add(
        dialogRef.afterClosed().subscribe((val) => {
          // this.subscription.add(this.reminderUpdate.sendMessage('true'));
          // this.getList();
          // this.reportCard.generateValueHistory();
        })
      );
    }
  }
  handleDistributionAndCommitmentData(data) {
    let result = [];
    let lastValue = data[0].position_value;
    let currentValue = lastValue;
    let lastSum = 0;

    for (let i = 0; i < data.length; i++) {
      const curr = data[i];
      if (curr.position_value !== currentValue) {
        // new value detected
        lastSum += currentValue;
        currentValue = curr.position_value;
      }
      result.push({
        ...curr,
        position_value: lastSum + currentValue,
        date: moment(curr.effective_date, 'YYYY-MM-DD').format('MMM DD, YYYY'),
      });
    }
    return result;
  }

  closeRefreshPrompt(event: Event) {
    event.stopPropagation();
    this.showRefreshPrompt = false;
    this.homeObsService.handleHomeReportRefresh(false, this.report?.id);
    this.cd.detectChanges();
  }
}
